const textFieldModalFilter = {
  action: 'Action',
  problem: 'Problem',
};

export default textFieldModalFilter;
